import React, { useRef, useEffect } from "react";

const testimonialsData = [
  { id: 1, name: "John Doe", comment: "Great work!", image: "https://randomuser.me/api/portraits/men/1.jpg" },
  { id: 2, name: "Jane Smith", comment: "Excellent service!", image: "https://randomuser.me/api/portraits/women/2.jpg" },
  { id: 3, name: "Michael Johnson", comment: "Very professional!", image: "https://randomuser.me/api/portraits/men/3.jpg" },
  { id: 4, name: "Emily Davis", comment: "Highly recommend!", image: "https://randomuser.me/api/portraits/women/4.jpg" },
  { id: 5, name: "Robert Wilson", comment: "Amazing experience!", image: "https://randomuser.me/api/portraits/men/5.jpg" },
  { id: 6, name: "Laura Brown", comment: "Friendly team!", image: "https://randomuser.me/api/portraits/women/6.jpg" },
  { id: 7, name: "James Miller", comment: "Exceeded expectations!", image: "https://randomuser.me/api/portraits/men/7.jpg" },
  { id: 8, name: "Sophia Taylor", comment: "Professional and reliable!", image: "https://randomuser.me/api/portraits/women/8.jpg" },
  { id: 9, name: "William Anderson", comment: "Great communication!", image: "https://randomuser.me/api/portraits/men/9.jpg" },
  { id: 10, name: "Olivia Thomas", comment: "Loved their work!", image: "https://randomuser.me/api/portraits/women/10.jpg" },
  { id: 11, name: "Daniel Martinez", comment: "Highly skilled!", image: "https://randomuser.me/api/portraits/men/11.jpg" },
  { id: 12, name: "Isabella Lee", comment: "Fantastic solutions!", image: "https://randomuser.me/api/portraits/women/12.jpg" },
];

export default function Testimonials() {
  const sliderRef = useRef(null);
  const cardWidth = 320; // Width of one card including gap

  // Clone first and last cards for seamless looping
  const slides = [
    testimonialsData[testimonialsData.length - 1],
    ...testimonialsData,
    testimonialsData[0],
  ];

  // Initialize scroll at first real card
  useEffect(() => {
    sliderRef.current.scrollLeft = cardWidth;
  }, []);

  // Infinite scroll adjustment
  const handleScroll = () => {
    if (!sliderRef.current) return;
    const maxScroll = cardWidth * (slides.length - 1);
    if (sliderRef.current.scrollLeft <= 0) {
      // Jump to last real card
      sliderRef.current.scrollLeft = maxScroll - 2 * cardWidth;
    } else if (sliderRef.current.scrollLeft >= maxScroll - cardWidth / 2) {
      // Jump to first real card
      sliderRef.current.scrollLeft = cardWidth;
    }
  };

  const scrollLeft = () => {
    sliderRef.current.scrollBy({ left: -cardWidth, behavior: "smooth" });
  };

  const scrollRight = () => {
    sliderRef.current.scrollBy({ left: cardWidth, behavior: "smooth" });
  };

  // Touch support
  let touchStartX = 0;
  const handleTouchStart = (e) => (touchStartX = e.touches[0].clientX);
  const handleTouchEnd = (e) => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (diff > 50) scrollRight();
    else if (diff < -50) scrollLeft();
  };

  // Auto-scroll every 5s
  useEffect(() => {
    const interval = setInterval(() => {
      scrollRight();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="testimonials-section">
      <h1 className="testimonials-heading">What Our Clients Say About Us</h1>

      <div className="testimonials-container">
        <button className="scroll-btn left" onClick={scrollLeft}>
          &#10094;
        </button>

        <div
          className="testimonials-slider"
          ref={sliderRef}
          onScroll={handleScroll}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          {slides.map((t, index) => (
            <div className="testimonial-card" key={index}>
              <p className="comment">"{t.comment}"</p>
              <div className="client-info">
                <img src={t.image} alt={t.name} />
                <h3>{t.name}</h3>
              </div>
            </div>
          ))}
        </div>

        <button className="scroll-btn right" onClick={scrollRight}>
          &#10095;
        </button>
      </div>
    </section>
  );
}
